import type { ModuleRoutes } from '@/routes'
import { Fragment } from 'react'
import { Route } from 'wouter'
import { Schools, MapSchools, ThroughLines } from './components/modules'
import { ModulesTypes } from './defs'
import { CoordBuffer, EntryMap, OpenedLine, PinArea } from '@/components/map/index'
import { BindPoiPopup } from '@/components/routes/BindPoiPopup'

declare const routes: Partial<Record<ModulesTypes, ModuleRoutes>>

declare const routesLines: () => void
declare const routesAround: () => void
const loadRoutes = () => {
  routesLines()
  routes.lines!.map = ({ path }) => (
    <Fragment key={path}>
      <Route path={path}>
        <EntryMap />
        <PinArea key={'area'} />
        <ThroughLines />
        <MapSchools />
      </Route>
      <Route
        path={path + '/:id/:direction/:stop?'}
        children={({ id, direction, stop }: { id: string; direction: 'forward' | 'backward'; stop?: string }) => (
          <Fragment>
            <EntryMap />
            <OpenedLine id={id} direction={direction} stop={stop} />
            <MapSchools />
          </Fragment>
        )}
      />
      <Route
        path={path + '/:line/:direction/:stop/timetable'}
        children={({ line, direction }: { line: string; direction: 'forward' | 'backward' }) => (
          <Fragment>
            <EntryMap />
            <OpenedLine id={line} direction={direction} />
            <MapSchools />
          </Fragment>
        )}
      />
    </Fragment>
  )

  routesAround()
  routes.around!.params = (_module, params) => ['poi', 'name', 'area', 'coord', ...params]

  routes.schools = {
    params: (_module, params) => ['poi', ...params],
    board: ({ path }) => (
      <Fragment key={path}>
        <Route path={path} children={<Schools />} />
      </Fragment>
    ),
    map: ({ path }) => (
      <Route key={path} path={path}>
        <EntryMap />
        <MapSchools />
        <CoordBuffer />
        <ThroughLines />
      </Route>
    ),
    searchTarget: ({ path }, result) => {
      switch (result.type) {
        case 'poi':
          return path

        default:
          return null
      }
    },
    route: ({ path }) => (
      <Route
        key={path}
        path={path}
        children={() => {
          return <BindPoiPopup />
        }}
      />
    ),
  }
}
__OVERRIDE(loadRoutes)
